import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import "./CreditPurchaseSuccess.scss";

export default function CreditPurchaseSuccess() {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get data from location state or use defaults
  const purchaseData = location.state || {
    reservePrice: 0,
    tier: "Regular",
    creditCost: 0,
    transactionId: "",
    creditsAvailable: 1,
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);
  };

  // Generate transaction ID if not provided
  const transactionId = purchaseData.transactionId || `TXN-${Date.now()}`;

  return (
    <div className="credit-purchase-success-page">
      <div className="container">
        <div className="page-header">
          <h1>Step 0: Purchase Auction Credit</h1>
        </div>

        <div className="success-content">
          {/* Credit Required Section */}
          <div className="credit-required-card">
            <h3 className="card-title">Credit Required</h3>
            <div className="card-content">
              <div className="info-row">
                <span className="label">Reserve Price:</span>
                <span className="value">{formatCurrency(purchaseData.reservePrice || 0)}</span>
              </div>
              <div className="info-row">
                <span className="label">Tier:</span>
                <span className={`tier-badge ${purchaseData.tier?.toLowerCase()}`}>
                  {purchaseData.tier || "Regular"}
                </span>
              </div>
              <div className="info-row">
                <span className="label">Credit Cost:</span>
                <span className="value credit-cost">{formatCurrency(purchaseData.creditCost || 0)}</span>
              </div>
            </div>
          </div>

          {/* Payment Successful Section */}
          <div className="payment-success-card">
            <div className="success-header">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="check-icon"
              >
                <path d="M20 6 9 17l-5-5"></path>
              </svg>
              <h3 className="card-title">Payment Successful</h3>
            </div>
            <div className="card-content">
              <div className="info-row">
                <span className="label">Transaction ID:</span>
                <span className="value">{transactionId}</span>
              </div>
              <div className="info-row">
                <span className="label">Credits Available:</span>
                <span className="value credits-available">
                  {purchaseData.creditsAvailable || 1} Credit{purchaseData.creditsAvailable !== 1 ? "s" : ""}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Info Banner */}
        <div className="info-banner">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="info-icon"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" x2="12" y1="16" y2="12"></line>
            <line x1="12" x2="12.01" y1="8" y2="8"></line>
          </svg>
          <p>
            You can now create an auction using this credit. The credit will be consumed when your auction goes live.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="action-buttons">
          <button className="btn-secondary" onClick={() => navigate("/auction/my/auctions")}>
            View My Auctions
          </button>
          <Link to="/auction/create" className="btn-primary">
            Create Auction
          </Link>
        </div>
      </div>
    </div>
  );
}
